var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle62BSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M50 53h-3V43h1.237a2.5 2.5 0 0 1 2.488 2.749L50 53ZM10 53h3V43h-1.238a2.5 2.5 0 0 0-2.487 2.749L10 53ZM47 53H13V43h34z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M9 53h42"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M9 6h10l.752 8.274A2.5 2.5 0 0 1 17.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L9 6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8 8 .223-.445A2.812 2.812 0 0 1 10.738 6h6.524c1.065 0 2.039.602 2.515 1.555L20 8"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M25 6h10l.752 8.274A2.5 2.5 0 0 1 33.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L25 6Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m24 8 .223-.445A2.813 2.813 0 0 1 26.738 6h6.524c1.065 0 2.039.602 2.515 1.555L36 8"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M41 6h10l.752 8.274A2.5 2.5 0 0 1 49.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L41 6Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m40 8 .223-.445A2.813 2.813 0 0 1 42.738 6h6.524c1.065 0 2.039.602 2.515 1.555L52 8"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M7.001 22.5a1.5 1.5 0 0 1 1.5-1.5h43a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5h-43a1.5 1.5 0 0 1-1.5-1.5v-15Z"
})));
SvgRectangle62BSelected.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle62BSelected);
export default ForwardRef;